export const asideEth_zh = {
    menu2: {
        onchain: "链上数据",
        onchain1: "大额交易",
        onchain2: "巨鲸地址列表",
        onchain18: "地址对应标记持有者名称关系列表",
        onchain19: "交易统计",
        technology: "技术指标",
        technology5: "日K线",
        technology8: "天针",
        technology6: "江卓尔60日累计涨幅",
        jzr60: "江卓尔60日累计涨幅",
        technology7: "arh999指标",
        technology11: "2年移动平均价格乘数",
        ma730: "2年移动平均价格乘数",
        address: "地址",
        address1: "活动地址",
        address2: "每日活跃地址数",
        address3: "每日发起交易地址数",
        address4: "每日收到交易地址数",
        address5: "新增地址",
        address6: "每日新增地址数",
        address7: "地址总数",
        transactions: "交易汇总",
        transactions4: "交易量",
        transactions5: "成交次数",
        transactions6: "日成交率",
        Distribution: "分配数据",
        Distribution1: "地址余额 ≥0.1",
        Distribution2: "地址余额 ≥0.01",
        Distribution3: "地址余额 ≥1",
        Distribution4: "地址余额 ≥10 ",
        Distribution5: "地址余额 ≥100",
        Distribution6: "地址余额 ≥1000",
        Distribution7: "地址余额 ≥10000 ",
        derivatives: "主要交易所衍生数据",
        derivatives1: "具体数据",
        derivatives2: "交易所日交易量",
        derivatives3: "交易所笔数变动",
        large5: "代币大额交易",
        ercBigDeals: "代币大额交易",
        large6: "代币交易量",
        reward: "抵押奖励",
        cnew: "新合约数",
        newContract: "新合约地址",
        ethTopAddrMonitorList: "巨鲸地址交易历史",
        tronUSDTBigTx: "USDT on TRON大额交易",
        tronUSDCBigTx: "USDC on TRON大额交易",
        tronUsdtVolume: "USDT on TRON交易量",
        tronUsdcVolume: "USDC on TRON交易量",
        dailyTrading: "日交易量",
        monitoring: "大额交易监控",
        usdt: "USDT交易量",
        usdt2: "USDT交易量",
        usdc: "USDC交易量",
        usdc2: "USDC交易量",
        busd: "BUSD交易量",
        busd2: "BUSD交易量",
        csusdc: "USDC流通量",
        csusdc2: "USDC流通量",
        csusdt: "USDT流通量",
        csbusd: "BUSD流通量",
        cstotal: "总流通量",
        PiCycleTopIndicator: "PI周期顶指标",
        goldenRatioMult: "黄金比例乘数",
        cdd: "币天销毁量",
        cdd2: "币天销毁量",
        dormancy: "已花费输出休眠平均天数",
        asol: "已花费输出平均寿命",
        asol2: "已花费输出平均寿命",
        cddwave: "币天销毁量年龄分布",
        cddwave2: "币天销毁量年龄分布",
        distribution: "地址数分布",
        supplyDistribution: "币数量分布",
        profitPercent: "盈利地址百分比",
        profit: "盈利地址数",
        loss: "亏损地址数",
        inflationRate: "通货膨胀率",
        issuance: "新币发行量",
        sopr: "已花费输出盈利比",
        sopr2: "已花费输出盈利比",
        velocity: "流通速度",
        nvtRatio: "市盈率",
        nvtRatio2: "市盈率",
        liveliness: "活跃度",
        frm: "交易费率乘数",
        supplyprofitPercent: "盈利百分比",
        supplyprofit: "盈利供应量",
        supplyloss: "盈利亏损量",
        nupl: "未实现的净收益损失比",
        nupl2: "未实现的净收益损失比",
        relativeUProfit: "未实现的净收益量",
        relativeULoss: "未实现的净亏损量",
        lthNUPL: "长持者未实现的净收益损失比",
        lthNUPL2: "长持者未实现的净收益损失比",
        sthNUPL: "短持者未实现的净亏损损失比",
        sthNUPL2: "短持者未实现的净亏损损失比",
        marketcap: "流通市值",
        marketcap2: "流通市值",
        rcap: "已实现流通市值",
        rcap2: "已实现流通市值",
        rprice: "已实现价格",
        mvrvRatio: "MVRV Ratio",
        mvrvRatio2: "MVRV Ratio",
        burnedSupply: "燃烧量",
        mintedSupply: "发行量",
        Miners:"矿工",
        Network:"网络",
        LongShort:"长/短期持有者",
        ProfitLoss:"盈亏",
        Lifetime:"币龄",
        Ratio:"比率",
        Token:"代币",
        balanceGroup:"按余额划分",
        Holder:"持有者分布",
        flux:"流通量",
        casting:"铸造",
        TradingVolume:"交易量",
        Bulk:"大额交易监控",
        USDTCasting:"USDT铸造量",
        USDTCasting2:"USDT铸造量",
        USDCCasting:"USDC铸造量",
        USDCCasting2:"USDC铸造量",
        BUSDCasting:"BUSD铸造量",
        BUSDCasting2:"BUSD铸造量",
        ethBalance:"交易所余额", 
        USDCMonitoring:"USDC大额交易",
        USDCMonitoring2:"USDC大额交易",
        USDTMonitoring:"USDT大额交易",
        USDTMonitoring2:"USDT大额交易",
        BUSDMonitoring:"BUSD大额交易",
        BUSDMonitoring2:"BUSD大额交易",


    },


};
export const asideEth_en = {
    menu2: {
        onchain1: "Big Amount Transaction",
        onchain18: "Addresses correspond to a relational list of tag holder names",
        onchain2: "Whales Address List",
        onchain19: "Transaction Statistics",
        technology: "Technical indicators",
        technology5: "Day K line",
        technology6: "Jiang Zhuoer 60-day Cumulative Gain",
        jzr60:"Jiang Zhuoer 60-day Cumulative Increase and Decrease",
        technology7: "Arh999 indicators",
        technology8: "Days needle",
        technology11: "2-Year MA Multiplier",
        ma730:"2 Years Moving Average Price Multiplier",
        address: "address",
        address1: "Activities address",
        address2: "Number of active addresses per day",
        address3: "Number of address initiates per day",
        address4: "Number of transaction addresses received per day",
        address5: "The new address",
        address6: "Number of newly added addresses per day",
        address7: "The total number of addresses",
        transactions: "The transactions",
        transactions4: "Trading volume",
        transactions5: "Clinch a deal the number",
        transactions6: "Day of closing",
        Distribution: "Distribution of data",
        Distribution1: "Address the balance ≥0.1",
        Distribution2: "Address the balance ≥0.01",
        Distribution3: "Address the balance ≥1",
        Distribution4: "Address the balance ≥10 ",
        Distribution5: "Address the balance ≥100",
        Distribution6: "Address the balance ≥1000",
        Distribution7: "Address the balance ≥10000 ",
        derivatives: "Major exchange derivatives data",
        derivatives1: "The specific data",
        derivatives2: "Daily exchange volume",
        derivatives3: "Changes in the number of transactions",
        large5: "ERC20 Token Big Amount Transaction",
        ercBigDeals:"ERC20 Token Big Amount Transaction History",
        large6: "ERC20 Token Daily Volume",
        reward: "ETH2 Staking Rewards",
        cnew: "Number of New Contract",
        newContract: "New Contracts",
        ethTopAddrMonitorList: "Top Address History",
        tronUSDTBigTx: "USDT(tron) big amount transaction",
        tronUSDCBigTx: "USDC(tron) big amount transaction",
        tronUsdtVolume: "usdt(tron) volume",
        tronUsdcVolume: "usdc(tron) volume",
        dailyTrading: "Daily trading volume",
        monitoring: "Large transaction monitoring",
        usdt: "USDT Volume",
        usdt2:"Onchain volume(USDT)",
        usdc: "USDC Volume",
        usdc2:"Onchain volume(USDC)",
        busd: "BUSD Volume",
        busd2:"Onchain volume(BUSD)",
        csusdc: "USDC Supply",
        csusdt: "USDT Supply",
        csbusd: "BUSD Supply",
        cstotal: "Total Supply",       
        PiCycleTopIndicator: "Pi Cycle Top Indicator",
        goldenRatioMult: "Golden Ratio Multiplier",
        cdd: "CDD",
        cdd2:"Coin Days Destroyed(CDD)",
        dormancy: "Dormancy",
        asol: "ASOL",
        asol2:"Average Spent Output Lifespan(ASOL)",
        cddwave: "Age Distribution Of CDD",
        cddwave2:"Age distribution of Coin Days Destoryed(CDD)",
        distribution: "Address Distribution of Holder",
        supplyDistribution: "Supply Distribution of Holder",
        profitPercent: "Percent of Address in Profit",
        profit: "Address in Profit",
        loss: "Address in Loss",
        inflationRate: "Inflation Rate",
        issuance: "Issuance ",
        sopr: "SOPR",
        sopr2:"Spent Output Profit Ratio (SOPR)",
        velocity: "Velocity",
        nvtRatio: "NVT Ratio",
        nvtRatio2:"Network Value To Transactions(NVT) Ratio",
        liveliness: "Liveliness",
        frm: "Fee Ratio Multiple(FRM)",
        supplyprofitPercent: "Percent Supply In Profit",
        supplyprofit: "Total Supply In Profit",
        supplyloss: "Total Supply In Loss",
        nupl: "NUPL",
        nupl2:"Net Unrealized Profit/Loss(NUPL)",
        relativeUProfit: "Unrealized Profit",
        relativeULoss: "Unrealized Loss",
        lthNUPL: "LTH NUPL",
        lthNUPL2:"Long Term Holder NUPL",
        sthNUPL: "STH NUPL",
        sthNUPL2:"Short Term Holder NUPL",
        marketcap: "Market Cap",
        marketcap2:"Market Cap [USD]",
        rcap: "Realized Cap",
        rcap2:"Realized Cap [USD]",
        rprice: "Realized Price",
        mvrvRatio: "MVRV Ratio",
        mvrvRatio2:"Market Value To Realized Value(MVRV) Ratio",
        burnedSupply: "Burned Supply",
        mintedSupply: "Minted Supply",
        Miners:"Miners",
        Network:"Network info",
        LongShort:"Long Short",
        ProfitLoss:"Profit/Loss",
        Lifetime:"Coin Lifespan",
        Ratio:"Ratio",
        Token:"Token",
        balanceGroup:"By Balance",
        Holder:"Holder",
        flux:"Circulating Supply",
        casting:"Number of Minted",
        TradingVolume:"Onchain Volume",
        Bulk:"Big Amount Transaction",
        USDTCasting:"USDT Minted",
        USDTCasting2:"Number of Minted(USDT)",
        USDCCasting:"USDC Minted",
        USDCCasting2:"Number of Minted(USDC)",
        BUSDCasting:"BUSD Minted",
        BUSDCasting2:"Number of Minted(BUSD)",
        ethBalance:"Exchange Balance (ETH)", 
        USDCMonitoring:"USDC transaction",
        USDCMonitoring2:"Big Amount transaction(USDC)",
        USDTMonitoring:"USDT transaction",
        USDTMonitoring2:"Big Amount transaction(USDT)",
        BUSDMonitoring:"BUSD transaction",
        BUSDMonitoring2:"Big Amount transaction(BUSD)",
    },


};